import styled from 'styled-components';

export { Paragraph, SectionHeading } from '../styles';

export const Hero = styled.section`
  display: flex;
  align-items: center;
  gap: 32px;
  padding: 40px;
  border-radius: 16px;
  background-color: ${({ theme }) => theme.colors.porterPrimary};
  color: ${({ theme }) => theme.colors.semantic.text.inverse};

  @media screen and (max-width: 767px) {
    flex-direction: column;
    align-items: flex-start;
    padding: 24px;
  }
`;

export const HeroImage = styled.img`
  flex-shrink: 0;
  width: 280px;
  max-width: 100%;
  height: auto;
  border-radius: 12px;
`;

export const HeroBody = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: 16px;
`;

export const HeroBadge = styled.span`
  padding: 8px 16px;
  border-radius: 999px;
  font-size: 12px;
  font-weight: 600;
  letter-spacing: 1px;
  text-transform: uppercase;
  background-color: ${({ theme }) => theme.colors.whiteShades(0.12)};
  color: ${({ theme }) => theme.colors.semantic.text.inverse};
`;

export const HeroHeading = styled.h1`
  margin: 0;
  font-size: 28px;
  font-weight: 700;
  line-height: 1.3;
  color: ${({ theme }) => theme.colors.semantic.text.inverse};

  @media screen and (max-width: 767px) {
    font-size: 24px;
  }
`;

export const HeroSubtitle = styled.p`
  margin: 0;
  font-size: 16px;
  line-height: 1.6;
  opacity: 0.8;
  color: ${({ theme }) => theme.colors.semantic.text.inverse};
`;

export const Banner = styled.section`
  display: flex;
  align-items: center;
  gap: 24px;
  padding: 40px;
  border-radius: 16px;
  overflow: hidden;
  background-color: ${({ theme }) => theme.colors.porterBlue500};
  color: ${({ theme }) => theme.colors.semantic.text.inverse};

  @media screen and (max-width: 767px) {
    flex-direction: column;
    align-items: flex-start;
    padding: 24px;
  }
`;

export const BannerBody = styled.div`
  flex: 1;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: 12px;
`;

export const BannerTitle = styled.h2`
  margin: 0;
  font-size: 24px;
  font-weight: 700;
  line-height: 1.3;
  color: ${({ theme }) => theme.colors.semantic.text.inverse};
`;

export const BannerText = styled.p`
  margin: 0;
  font-size: 16px;
  line-height: 1.6;
  opacity: 0.9;
  color: ${({ theme }) => theme.colors.semantic.text.inverse};
`;

export const BannerImage = styled.img`
  flex-shrink: 0;
  width: 320px;
  max-width: 100%;
  height: auto;
  border-radius: 12px;
  object-fit: cover;
`;

export const BannerButton = styled.a`
  flex-shrink: 0;
  padding: 16px 32px;
  border-radius: 12px;
  font-size: 16px;
  font-weight: 700;
  text-decoration: none;
  background-color: ${({ theme }) => theme.colors.porterLime200};
  color: ${({ theme }) => theme.colors.porterPrimary};

  &:hover {
    text-decoration: none;
    color: ${({ theme }) => theme.colors.porterPrimary};
  }
`;
